'use client';

import { SideMenu } from '@/components/side-menu';

export default function SideMenuShell() {
  return <SideMenu />;
}
